/* ─── RadioGroup ─── */

.group {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.group[data-orientation="horizontal"] {
  flex-direction: row;
  gap: var(--space-4);
}

/* ─── Radio item wrapper ─── */

.item {
  display: inline-flex;
  align-items: flex-start;
  gap: var(--space-3);
  cursor: pointer;
}

.item[data-disabled] {
  cursor: not-allowed;
  opacity: 0.38;
}

/* ─── Radio circle ─── */

.radio {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  flex-shrink: 0;
  margin-block-start: 0.125rem; /* align with label text */
  border: 2px solid var(--md-outline);
  border-radius: 50%;
  background: transparent;
  cursor: inherit;
  transition: border-color var(--motion-duration-short3)
    var(--motion-easing-standard);
}

.radio[data-checked] {
  border-color: var(--md-primary);
}

.radio:focus-visible {
  --focus-ring-offset: var(--focus-ring-offset-outset);
}

/* ─── Inner dot ─── */

.indicator {
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 50%;
  background: var(--md-primary);
  transform: scale(0);
  transition: transform var(--motion-duration-short3)
    var(--motion-easing-standard);
}

.radio[data-checked] .indicator {
  transform: scale(1);
}

/* ─── Label ─── */

.label {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  font-family: var(--font-sans);
  color: var(--md-on-surface);
  cursor: inherit;
  user-select: none;
}

.text {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

/* ─── Description ─── */

.description {
  font: var(--type-body-md);
  letter-spacing: var(--tracking-body-md);
  color: var(--md-on-surface-variant);
  cursor: inherit;
  user-select: none;
}

.group[data-size="sm"][data-orientation="horizontal"] {
  gap: var(--space-3);
}

.group[data-size="sm"] .item {
  align-items: center;
  gap: var(--space-2);
  min-block-size: 1.5rem;
}

.group[data-size="sm"] .radio {
  margin-block-start: 0;
}

.group[data-size="sm"] .label {
  font: var(--type-body-md);
  letter-spacing: var(--tracking-body-md);
  font-family: var(--font-sans);
}
